import { Box, IconButton, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React from "react";

export const EmptyDealBox = (props) => {
  const { index, description, onClick } = props;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 10px",
      }}
      onClick={() => onClick(index)}
    >
      <Typography variant="body1" sx={{ alignSelf: "center" }}>
        {description}
      </Typography>
      <IconButton>
        <AddIcon />
      </IconButton>
    </Box>
  );
};
